import React, { useState, useEffect } from 'react';
import '../CSS/Global.css';
import { useSidebar } from '../SidebarContext';
import Header from './Header';
import Sidebar from './SideBar';
import TeamDirectoryModal from './TeamDirectoryModal';

const TeamDirectory = () => {
    const { isSidebarOpen } = useSidebar();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [datatable, setdataTable] = useState([])

    // State Variables
    const [searchQuery, setSearchQuery] = useState('');
    const isLoggedIn = JSON.parse(localStorage.getItem("2xgxgshdugyywerw12gh")) || "";
    const [employees, setEmployees] = useState([
        // Sample data (replace with actual data)

    ]);
    const [filteredEmployees, setFilteredEmployees] = useState(employees);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;
    const [skillsInput, setSkillsInput] = useState(''); // Temporary raw input for skills
    const [languages, setLanguages] = useState([]);
    const [languagesInput, setLanguagesInput] = useState('');
    const [hobbiesInput, setHobbiesInput] = useState('');
    const [departMentName, setDepartMentName] = useState([]);
    const [skills, setSkills] = useState([]);
    const [weeklyHoliday, setWeeklyHoliday] = useState([]);
    const [hobbies_interest, setHobbies] = useState([]);
    const [staff, setStaff] = useState({
        firstName: "",
        username: "",
        lastName: "",
        emplyee_ID: "",
        dob: "",
        gender: "",
        profilePic: "",
        address: "",
        phone: "",
        email: "",
        emergency_contact_name: "",
        emergency_contact_phone: "",
        employ_details: "",
        job_title: "",
        department: [],
        dof_joining: "",
        employ_status: "",
        report_manager: "",
        class_location: "",
        profess_info: "",
        qualifications: "",
        prev_exp: "",
        skills: [],
        certifications: "",
        language_known: [],
        payroll_info: "",
        salary_details: "",
        account_no: "",
        ifsc_code: "",
        bank_name: "",
        provident_fund_number: "",
        other_info: "",
        marital_status: "",
        spouse_name: "",
        children_details: "",
        hobbies_interest: [],
        password: "",
        cp_id: isLoggedIn.user_id,
    })

    const handleBlurOrEnter = (setter, inputSetter, value, fieldNameInStaff) => {
        const values = value
            .split(",")
            .map((item) => item.trim())
            .filter((item) => item); // Removes empty items

        setter((prev) => {
            const updated = [...prev, ...values];
            setStaff((prevStaff) => ({
                ...prevStaff,
                [fieldNameInStaff]: updated // ✅ Update inside staff also
            }));
            return updated;
        });

        inputSetter(""); // Clear input field
    };


    const removeTag = (setter, indexToRemove) => {
        setter((prev) => prev.filter((_, index) => index !== indexToRemove));
    };

    const weeklyHolidayOptions = [
        { value: "Monday", label: "Monday" },
        { value: "Tuesday", label: "Tuesday" },
        { value: "Wednesday", label: "Wednesday" },
        { value: "Thursday", label: "Thursday" },
        { value: "Friday", label: "Friday" },
        { value: "Saturday", label: "Saturday" },
        { value: "Sunday", label: "Sunday" },
    ];

    const genderOptions = [
        { value: "", label: "Select gender" },
        { value: 'male', label: 'Male' },
        { value: 'female', label: 'Female' },
        { value: 'other', label: 'Other' },
    ];

    const fetchDataDepartment = async () => {
        try {
            const response = await fetch(`https://100billionoms.com/department/allget/${isLoggedIn.user_id}`);
            const res = await response.json();

            const activeDepartments = res.filter(item => item.status === 'Active');

            const uniqueDepartments = Array.from(
                new Map(activeDepartments.map(item => [item.department_name?.toLowerCase(), item])).values()
            );

            setDepartMentName(uniqueDepartments);
        } catch (error) {
            console.error(error);
        }
    };

    const departmentOptions = departMentName.map(dept => ({
        value: dept.department_name.toLowerCase(),
        label: dept.department_name
    }));

    const employmentStatusOptions = [
        { value: 'full-time', label: 'Full-Time' },
        { value: 'part-time', label: 'Part-Time' },
        { value: 'contract', label: 'Contract' },
    ];

    const maritalStatusOptions = [
        { value: 'single', label: 'Single' },
        { value: 'married', label: 'Married' },
        { value: 'divorced', label: 'Divorced' },
    ];

    const handleChange = (e) => {
        const { name, value } = e.target;

        setStaff(prevState => {
            let updatedState = { ...prevState, [name]: value };

            // Generate username if firstName or lastName changes
            if (name === "firstName" || name === "lastName") {
                const first = updatedState.firstName.trim().toLowerCase();
                const last = updatedState.lastName.trim().toLowerCase();
                const randomNum = Math.floor(1000 + Math.random() * 9000); // Generate a random 4-digit number
                updatedState.username = `${first}${last}${randomNum}`;
            }

            return updatedState;
        });
    };



    const handleFileChange = (e) => {
        const { name, files } = e.target;
        setStaff(prevState => ({
            ...prevState,
            [name]: files[0],
        }));
    };

    const handleGenresChange = (selectedOptions) => {
        setStaff(prevState => ({
            ...prevState,
            department: selectedOptions ? selectedOptions.map(option => option.value) : [],
        }));
    };

    useEffect(() => {
        fetchDataDepartment();
    }, [])

    // Effect to handle filtering
    useEffect(() => {
        const filtered = employees.filter((employee) =>
            Object.values(employee).some((value) =>
                String(value).toLowerCase().includes(searchQuery.toLowerCase())
            )
        );
        setFilteredEmployees(filtered);
        setCurrentPage(1); // Reset to first page on new search
    }, [searchQuery, employees]);

    // Pagination Logic
    const totalPages = Math.ceil(filteredEmployees.length / itemsPerPage);
    const currentData = filteredEmployees.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    // Handlers
    const handleSearch = (e) => setSearchQuery(e.target.value);

    const paginate = (pageNumber) => setCurrentPage(pageNumber);


    // let handleSubmit = async (e) => {
    //     e.preventDefault();

    //     const formDataToSubmit = new FormData();

    //     Object.keys(staff).forEach(key => {
    //         if (key === 'department' || key === 'skills' || key === 'language_known' || key === "hobbies_interest") {
    //             // Special handling for cast_crew to ensure each entry is correctly formatted with images

    //             formDataToSubmit.append(key, JSON.stringify(staff[key]));

    //         } else if (key === 'profilePic') {
    //             formDataToSubmit.append(key, staff[key]); // Append file directly
    //         } else {
    //             formDataToSubmit.append(key, staff[key]);
    //         }
    //     });

    //     formDataToSubmit.append("weekly_holiday", JSON.stringify(weeklyHoliday));

    //     // Log formData entries for debugging
    //     for (let [key, value] of formDataToSubmit.entries()) {
    //         console.log(`${key}: ${value}`);
    //     }

    //     try {
    //         const response = await fetch('https://100real.xyz/staffregister/igothousifyu', {
    //             method: 'POST',
    //             body: formDataToSubmit,
    //         });



    //         if (response.ok) {
    //             const res = await response.json();
    //             console.log(res);


    //             await fetchData(); // Fetch updated data


    //         }
    //     } catch (error) {
    //         console.log(error);
    //     }
    // }

    const handleSubmit = async (e) => {
        e.preventDefault();

        const formDataToSubmit = new FormData();

        Object.keys(staff).forEach(key => {
            if (["department", "skills", "language_known", "hobbies_interest", "weekly_holiday"].includes(key)) {
                formDataToSubmit.append(key, JSON.stringify(staff[key]));
            } else if (key === 'profilePic') {
                formDataToSubmit.append(key, staff[key]);
            } else {
                formDataToSubmit.append(key, staff[key]);
            }
        });


        // formDataToSubmit.append("weekly_holiday", JSON.stringify(weeklyHoliday));



        const url = staff.id
            ? `https://100real.xyz/staffregister/change/${staff.emplyee_ID}`
            : 'https://100real.xyz/staffregister/igothousifyu';

        const method = staff.id ? 'PUT' : 'POST';

        try {
            const response = await fetch(url, {
                method,
                body: formDataToSubmit,
            });

            if (response.ok) {
                const res = await response.json();
                console.log(res);
                await fetchData();
                setIsModalOpen(false);
            } else {
                console.error("Failed to submit staff data");
            }
        } catch (error) {
            console.error("Error submitting form:", error);
        }
    };

    console.log(staff)
    const fetchData = async () => {
        try {
            let response = await fetch(`https://100real.xyz/staffregister/allget/${isLoggedIn.user_id}`);
            let res = await response.json();

            // Parse specific fields
            const parsedData = res.map((employee) => ({
                ...employee,
                department: JSON.parse(employee.department || "[]"),
                skills: JSON.parse(employee.skills || "[]"),
                language_known: JSON.parse(employee.language_known || "[]"),
                hobbies_interest: JSON.parse(employee.hobbies_interest || "[]"),
                weekly_holiday: JSON.parse(employee.weekly_holiday || "[]"),
            }));

            setEmployees(parsedData);
            console.log(parsedData);
        } catch (error) {
            console.log("Error fetching staff data:", error);
        }
    };

    const toggleStatus = async (employeeId, currentStatus) => {
        try {
            const res = await fetch(`https://100real.xyz/staffregister/toggle-status/${employeeId}`, {
                method: 'PATCH'
            });

            if (res.ok) {
                const { updatedEmployee } = await res.json();
                setEmployees(prev =>
                    prev.map(emp =>
                        emp.emplyee_ID === updatedEmployee.emplyee_ID
                            ? { ...emp, status: updatedEmployee.status }
                            : emp
                    )
                );
            } else {
                console.error("Failed to update status");
            }
        } catch (error) {
            console.error("Error updating status:", error);
        }
    };


    const handleDelete = async (id) => {
        try {
            const res = await fetch(`https://100real.xyz/staffregister/${id}`, {
                method: 'DELETE'
            });

            if (res.ok) {
                setEmployees(prev => prev.filter(emp => emp.id !== id));
            } else {
                console.error("Failed to delete employee");
            }
        } catch (error) {
            console.error("Error deleting employee:", error);
        }
    };




    useEffect(() => {
        fetchData();
    }, [])

    return (
        <>
            <Header />
            <Sidebar />
            <div className={`open-close ${isSidebarOpen ? 'open' : 'closed'}`}>
                <div className="oms-header">
                    <h1 className="dashboard-title">Team Directory</h1>

                    {/* Add Fees Button */}
                    <button
                        className="oms-add-btn"
                        onClick={() => {
                            // Clear the form
                            setStaff({
                                firstName: "",
                                username: "",
                                lastName: "",
                                emplyee_ID: "",
                                dob: "",
                                gender: "",
                                profilePic: "",
                                address: "",
                                phone: "",
                                email: "",
                                emergency_contact_name: "",
                                emergency_contact_phone: "",
                                employ_details: "",
                                job_title: "",
                                department: [],
                                dof_joining: "",
                                employ_status: "",
                                report_manager: "",
                                class_location: "",
                                profess_info: "",
                                qualifications: "",
                                prev_exp: "",
                                skills: [],
                                certifications: "",
                                language_known: [],
                                payroll_info: "",
                                salary_details: "",
                                account_no: "",
                                ifsc_code: "",
                                bank_name: "",
                                provident_fund_number: "",
                                other_info: "",
                                marital_status: "",
                                spouse_name: "",
                                children_details: "",
                                hobbies_interest: [],
                                password: "",
                                cp_id: isLoggedIn.user_id,
                                weekly_holiday: []
                            });

                            setSkills([]);
                            setLanguages([]);
                            setHobbies([]);
                            setSkillsInput("");
                            setLanguagesInput("");
                            setHobbiesInput("");
                            setIsModalOpen(true);
                        }}
                    >
                        Add employee
                    </button>

                </div>

                {/* Search Filter */}
                <div className="filter-search">
                    <div className="filter-search-input">
                        <input
                            type="search"
                            placeholder="Search..."
                            value={searchQuery}
                            onChange={handleSearch}
                        />
                        <i className="fa fa-search"></i> {/* Font Awesome Search Icon */}
                    </div>
                </div>

                {/* Team Directory Table */}
                <div className="customer-table">
                    <table>
                        <thead>
                            <tr>
                                <th>DOB</th>
                                <th>Name</th>
                                <th>Gender</th>
                                <th>Department</th>
                                <th>Employee ID</th>
                                <th>Mobile</th>
                                <th>Job Title</th>
                                <th>Status</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentData.length > 0 ? (
                                currentData.map((employee, index) => (
                                    <tr key={index}>
                                        <td>{employee.dob}</td>
                                        <td>{employee.firstName} {employee.lastName}</td>
                                        <td>{employee.gender}</td>
                                        <td>{employee.department}</td>
                                        <td>{employee.emplyee_ID}</td>
                                        <td>{employee.phone}</td>
                                        <td>{employee.job_title}</td>
                                        <td>{employee.status}</td>
                                        <td>
                                            <button onClick={() => {
                                                setStaff(employee);
                                                setSkills(employee.skills || []);
                                                setLanguages(employee.language_known || []);
                                                setHobbies(employee.hobbies_interest || []);
                                                setWeeklyHoliday(Array.isArray(employee.weekly_holiday)
                                                    ? employee.weekly_holiday
                                                    : JSON.parse(employee.weekly_holiday || "[]"));

                                                setIsModalOpen(true);
                                            }}>
                                                <i className="fa fa-pen"></i>
                                            </button>

                                            <button onClick={() => toggleStatus(employee.emplyee_ID, employee.status)}>
                                                <i className={`fa ${employee.status === 'Active' ? 'fa-toggle-on' : 'fa-toggle-off'}`}></i>
                                            </button>

                                            <button onClick={() => handleDelete(employee.id)}>
                                                <i className="fa-solid fa-trash delete-oms"></i>
                                            </button>

                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="8" style={{ textAlign: 'center' }}>
                                        No employees found.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                {/* Pagination */}
                <div className="pagination">
                    <button
                        onClick={() => paginate(currentPage - 1)}
                        disabled={currentPage === 1}
                    >
                        Previous
                    </button>
                    {Array.from({ length: totalPages }, (_, index) => (
                        <button
                            key={index}
                            onClick={() => paginate(index + 1)}
                            className={currentPage === index + 1 ? 'active' : ''}
                        >
                            {index + 1}
                        </button>
                    ))}
                    <button
                        onClick={() => paginate(currentPage + 1)}
                        disabled={currentPage === totalPages}
                    >
                        Next
                    </button>
                </div>
            </div>

            <TeamDirectoryModal
                skillsInput={skillsInput}
                setSkillsInput={setSkillsInput}
                languages={languages}
                setLanguages={setLanguages}
                languagesInput={languagesInput}
                setLanguagesInput={setLanguagesInput}
                hobbiesInput={hobbiesInput}
                setHobbiesInput={setHobbiesInput}
                skills={skills}
                setSkills={setSkills}
                weeklyHoliday={weeklyHoliday}
                setWeeklyHoliday={setWeeklyHoliday}
                hobbies_interest={hobbies_interest}
                setHobbies={setHobbies}
                staff={staff}
                setStaff={setStaff}
                handleBlurOrEnter={handleBlurOrEnter}
                removeTag={removeTag}
                weeklyHolidayOptions={weeklyHolidayOptions}
                genderOptions={genderOptions}
                departmentOptions={departmentOptions}
                employmentStatusOptions={employmentStatusOptions}
                maritalStatusOptions={maritalStatusOptions}
                handleChange={handleChange}
                handleFileChange={handleFileChange}
                handleGenresChange={handleGenresChange}
                handleSubmit={handleSubmit}
                isOpen={isModalOpen} setIsOpen={setIsModalOpen} />
        </>
    );
};

export default TeamDirectory;
